import { datetime } from "../../util/library/datetime";
import { createSliceSelector } from "../../util/store/selectors";
import { ACTION_TYPE } from "../../util/varibles/constants";
import { getKeyWeek } from "../../util/varibles/global";
import {
    IActivityLog,
    ILevelByVessel,
    ILevelByVessel2,
    IOperation,
    IOperations,
    IServiceRequest,
    IServiceTask,
    ISite,
    IUnit,
    IVessel,
    TOperation
} from "../../util/varibles/interface";

export const createCurrentTime = (): { weeks: string[] } => {
    const weeks: string[] = [];
    const monday = datetime().startOf('week').value;
    for (let i = -7; i < 7; i++) {
        const time = datetime(monday).add(i, 'week').time;
        const key = getKeyWeek(time);
        weeks.push(key);
    }

    return { weeks };
};

export const CALENDAR_ID = 'calendar';
export const LAYOUT_CALENDER = 'layout-calendar';

export enum SUPPORT_TYPE {
    MAIN = 'main',
    SUB = 'sub'
}

export enum TYPE_SUBMIT {
    ALL,
    CURRENT_WEEK,
}

export interface IFishChanges {
    [id: string]: {
        [opId: string]: number
    }
}

export interface IFetching {
    confirm: boolean
}

export interface PlanOperationState {
    operations: IOperations
    operationsDelete: { [index: string]: IOperation[] }
    level: ILevelByVessel
    level2: ILevelByVessel2
    fishChanges: IFishChanges

    beforeCount: boolean
    afterCount: boolean
    indexId: number
    weeks: string[]
    popupClose: boolean

    canceled: IOperation[]
    sites: ISite[]
    routeIds: string[]
    vessels: IVessel[]
    harvests: any[]
    serviceRequests: IServiceRequest[]

    serviceTasks: IServiceTask[]

    files: any;
    opFocusId: any

    isFetching: IFetching
    loadingSites: boolean
    loadingServiceRequests: boolean
    loadingVessels: boolean
    loadingLazy: boolean

    popupOperation: {
        isShow: boolean
        isAllowChange?: boolean
        operationType?: any
        limitOperationTypes?: any
        editMode?: ACTION_TYPE
        values?: {
            vessel: IVessel
            operation: TOperation
            activity_log: IActivityLog[]
            store?: { [id: string]: IUnit }
            [id: string]: any
        }
        location?: ISite
        action?: any
    }
}

export const initialState: PlanOperationState = {
    operations: {},
    operationsDelete: {},
    level: {},
    level2: {},
    fishChanges: {},

    beforeCount: false,
    afterCount: false,
    indexId: 1,
    popupClose: false,

    canceled: [],
    sites: [],
    routeIds: [],
    vessels: [],
    harvests: [],
    serviceTasks: [],
    serviceRequests: [],

    files: {},
    opFocusId: null,

    isFetching: {
        confirm: false,
    },
    loadingSites: false,
    loadingServiceRequests: false,
    loadingVessels: false,
    loadingLazy: false,

    popupOperation: { isShow: false, operationType: null },

    ...createCurrentTime()
};

export interface IUpdateOp {
    update?: IOperations
    add?: IOperations
    files?: any
    isCheck?: boolean
    isFocus?: string | number
    deleteIds?: {
        [id: string]: string[]
    }
    blockIds?: string[]
}

const { root, selector } = createSliceSelector(state => state.planOperation);

export const selectPlan = {
    root,
    ops: selector(s => s.operations),
    popupEdit: selector(s => s.popupOperation),
    level: selector(s => s.level),
    opsCanceled: selector(s => s.canceled),
    opsDelete: selector(s => s.operationsDelete),
    vessels: selector(s => s.vessels ?? []),
    weeks: selector(s => s.weeks),
    beforeCount: selector(s => s.beforeCount),
    afterCount: selector(s => s.afterCount),
    files: selector(s => s.files),
    fishChanges: selector(s => s.fishChanges),
    sites: selector(s => s.sites),
    harvests: selector(s => s.harvests),
    serviceRequests: selector(s => s.serviceRequests),
    loadingSites: selector(s => s.loadingSites),
    loadingServiceRequest: selector(s => s.loadingServiceRequests),
    opFocusId: selector(s => s.opFocusId),
    popupClose: selector(s => s.popupClose),
    indexId: selector(s => s.indexId),
    routeIds: selector(s => s.routeIds),
    canceled: selector(s => s.canceled),
    loadingSend: selector(s => s.isFetching.confirm),
    loadingVessels: selector(s => s.loadingVessels),
    loadingLazy: selector(s => s.loadingLazy),
};